export default "__VITE_ASSET__521b0126__"